import { useEffect, useState } from "react"
import type { SuccessFetch } from "../../../../../../types"
import { useApi } from "../../../../../../utils" 
import { FormType } from "../../types"

interface FilteredParams {
  page?: number
  keyword?: string
  limit?: number
  sort?: string
}

interface DataType{
  payload: FormType[]
  pagination_data: {
    total: number
    page: number
    size: number
    pages: number
  }
}

export function useList({ page, keyword, limit, sort }: FilteredParams) {
   // Vars
   const defaultValue = {
    payload: [],
    pagination_data: {
      page: 0,
      pages: 0,
      size: 0,
      total: 0
    }
  }

  const api = useApi()
  const [data, setData] = useState<DataType>(defaultValue)
  const [isLoading, setLoading] = useState(true)

  const params: { [key: string]: number | string | undefined } = {}
  if (page) params.page = page; 
  if (keyword) params.search = keyword; 
  if (limit) params.limit = limit; 
  if (sort) params.sort = sort;
  
  const fetchUrl = () => {
      return api.get("/opening-stock?only_active=true", {params})
  }

  const fetchData = () => {
    setLoading(true)

    fetchUrl()
    // .then((res: SuccessFetch<{ payload: DataType }>) => {
      .then((res: SuccessFetch<DataType>) => {
      setData(res.data)
    })
    .catch(() => {
      setData(defaultValue)
    }).finally(() => {
      setLoading(false)
    })
  }

  const refetch = () => fetchData()

  useEffect(() => {
    fetchData()

    return () => {
      setData(defaultValue)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [page, keyword, limit, sort])

  return { data, isLoading, refetch }
}

